import { ApolloCache } from '@apollo/client';
import { myRenewalMissedQuery } from './operations';

export function clearMissedRenewal(cache: ApolloCache<unknown>) {
    cache.writeQuery({ query: myRenewalMissedQuery, data: { myRenewalMissed: false } });
}
